var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTether({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tether",
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.672,
    height: 34.512,
    viewBox: "0 0 39.672 34.512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_689",
    "data-name": "Path 689",
    d: "M8.287,21.889,1.053,37.084a.3.3,0,0,0,.064.341L20.654,56.149a.3.3,0,0,0,.412,0L40.6,37.428a.294.294,0,0,0,.064-.343l-7.234-15.2a.29.29,0,0,0-.267-.17H8.554a.291.291,0,0,0-.269.169Z",
    transform: "translate(-1.024 -21.72)",
    fill: "#326758",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_690",
    "data-name": "Path 690",
    d: "M111.466,95.734h0c-.132.012-.812.059-2.333.059-1.207,0-2.064-.042-2.365-.059h0c-4.665-.241-8.147-1.2-8.147-2.332s3.484-2.087,8.149-2.336v3.719c.305.026,1.179.085,2.386.085a22.6,22.6,0,0,0,2.3-.085V91.069c4.655.244,8.129,1.2,8.129,2.333s-3.473,2.089-8.129,2.33h0Zm0-5.05V87.351h6.5V82.28h-17.69v5.075h6.5v3.327c-5.28.285-9.25,1.511-9.25,2.98s3.971,2.695,9.25,2.98v10.665h4.694V96.638c5.267-.284,9.231-1.509,9.231-2.977s-3.96-2.688-9.231-2.979h0ZM111.466,90.684Z",
    transform: "translate(-89.274 -77.105)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTether);
export default __webpack_public_path__ + "static/media/tether.05b14c4b8075e17b8d10e5074633e17c.svg";
export { ForwardRef as ReactComponent };